import config from 'config'
import lang from '@/lang'

import { expenseStates } from '@/modules/base/util/constants'

const urlPrefix = `${config.resourceHost}expense`
const listSettingUrl = `${config.resourceHost}setting/userlist/expense`

const {
  IN_PROGRESS,
  OPEN,
  PAID,
  PARTIALLYPAID,
  ISOVERDUE,
  ISDUE,
  TO_ANALYZE,
  DRAFT,
  ANALYZE_ERROR,
} = expenseStates

export const urls = {
  resource: urlPrefix,
  listSetting: listSettingUrl,
  sort: `${listSettingUrl}/sort`,
  columns: `${listSettingUrl}/columns`,
  multiple: 'expenses',
}

const resourceUrl = `${config.resourceHost}expense`

const expenseConfig = {
  urls,
  resourceUrl,
  uploadUrl: `${config.resourceHost}deltraservicesimage/uploadexpensefile`,
  deleteExpenseFileUrl: `${config.resourceHost}cachedata`,
  receiptBaseUrl: config.resourceHost,
  receiptUrl: `${resourceUrl}/receipt`,
  searchUrl: `${resourceUrl}/search`,

  expenseListSetting: listSettingUrl,
  defaultReceiptNumber: '-',

  routes: {
    details: '/expense',
    list: `${config.resourceHost}${urls.multiple}`,
    listView: `/${urls.multiple}`,
    new: '/expense/new',
    edit: id => `/expense/edit/${id}`,
  },

  ocrFieldSelectOptions: [
    { label: lang.receipt.form.payee.label, value: 'payee', hiddenIfPaid: true },
    { label: lang.receipt.form.receiptNumber, value: 'receiptNumber', hiddenIfPaid: false },
    { label: lang.receipt.form.date, value: 'date', hiddenIfPaid: true },
    { label: lang.receipt.form.description, value: 'description', hiddenIfPaid: false },
    { label: lang.banking.modal.amount, value: 'priceTotal', hiddenIfPaid: false },
  ],

  fineUploader: {
    messages: {
      minSizeError: lang.expenseFileMinSizeError,
      sizeError: lang.expenseFileMaxSizeError,
      typeError: lang.expenseFileTypeError,
    },
    validation: {
      acceptFiles: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'],
      allowedExtensions: ['jpg', 'jpeg', 'pdf', 'png'],
      sizeLimit: 25 * 1024 * 1024, // 25 mb
    },
    scaling: {
      sendOriginal: false,
      sizes: [
        { name: '', maxSize: 3000 },
      ],
    },
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: 'draft',
      title: lang.toProcess,
      quickFilter: {
        state: {
          type: 'set',
          values: [DRAFT],
        },
      },
    },
    {
      name: 'toAnalyze',
      title: lang.toAnalyze,
      quickFilter: {
        state: {
          type: 'set',
          values: [TO_ANALYZE],
        },
      },
    },
    {
      name: 'analyzeError',
      title: lang.analyzeError,
      quickFilter: {
        state: {
          type: 'set',
          values: [ANALYZE_ERROR],
        },
      },
    },
    {
      name: 'open',
      title: lang.open,
      quickFilter: {
        state: {
          type: 'set',
          values: [OPEN],
        },
      },
    },
    {
      name: 'inProgress',
      title: lang.inProgress,
      quickFilter: {
        state: {
          type: 'set',
          values: [IN_PROGRESS],
        },
      },
    },
    {
      name: 'paid',
      title: lang.paid,
      quickFilter: {
        state: {
          type: 'set',
          values: [PAID],
        },
      },
    },
    {
      name: 'partiallyPaid',
      title: lang.partiallyPaid,
      quickFilter: {
        state: {
          type: 'set',
          values: [PARTIALLYPAID],
        },
      },
    },
    {
      name: 'overdue',
      title: lang.overdue,
      quickFilter: {
        state: {
          type: 'set',
          values: [ISOVERDUE],
        },
      },
    },
    {
      name: 'due',
      title: lang.due,
      quickFilter: {
        state: {
          type: 'set',
          values: [ISDUE],
        },
      },
    },
  ],
}

export default expenseConfig
